import React, { useEffect, useRef, useState } from 'react';
import { View, SafeAreaView, KeyboardAvoidingView, TouchableOpacity } from 'react-native';
import { Icon, Text } from '@components';
import { connect } from 'react-redux';
import { BaseColor } from '../../config/theme';
import { AlertComponent, Button, Header, Image, TextInput } from '../../components';
import { BaseStyle } from '../../config';
import { Platform } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import styles from './styles';
import Menu from '../../components/Menu';
import * as ImagePicker from 'expo-image-picker';
import { createPosition, saveImg } from '../../helpers/apis';
import { showMessage } from 'react-native-flash-message';
import { compressImage } from '../../helpers/functions';
import CostumModal from '../../components/CostumModal';
import PostOptions from '../../components/PostOptions';
import { clientActions, userActions } from '../../redux/actions';

const authorisations = [
    {
        type: 'AA',
        id: 1,
        description: "Zugriff auf allen Aktionen inkl. aller Märkte"
    },
    {
        type: 'ZA',
        value: 2,
        description: "Zugriff auf zugewiesenen Aktionen inkl. aller Märkte aus diesen Aktionen"
    },
    {
        type: 'ZM',
        value: 3,
        description: "Zugriff auf zugewiesenen Märkte"
    },
];
function CreatePosition({ navigation, getAllClient, route }) {
    const offsetKeyboard = Platform.select({
        ios: 0,
        android: 60,
    });

    const [state, setState] = useState({
        title: '',
        abbreviation: '',
        description: '',
        access:"",
        authorisations: [],
        clientId: route.params.clientId
    });

    useEffect(() => {
        getAllClient();
    }, []);
    const setForm = (name, value) => {
        setState((s) => ({ ...s, [name]: value }));
    };
    function handleSubmit() {
        if (
            !(
                !state.creating &&
                state.title &&
                state.abbreviation &&
                state.access
            )
        ) {
            setState((s) => ({
                ...s,
                titleError: state.title ? '' : 'Title erforderlich',
                abbreviationError: state.abbreviation ? '' : 'Abkürzung erforderlich',
                accessError: state.access ? '' : 'Zufriff erforderlich',
            }));
            return;
        }
        const { title, abbreviation, description, access } = state;
        setForm('creating', true);
        createPosition(
            { title, abbreviation, description, access, clientId: state.clientId },
            (position) => {
                setForm('creating', false);
                route.params.onCreated?.({...position, users:[]})
                navigation.goBack();
            },
            () => setForm('creating', false)
        );
    }
    

    const abbreviationInput = useRef(null);
    const descriptionInput = useRef(null);

    return (
        <View style={{ flex: 1, position: 'relative' }}>
            <Header
                title="Position anlegen"
                subTitle={`Bei ${route.params.clientName}`}
                //shadow
                renderLeft={() => {
                    return <Icon name="arrowleft" size={25} type="ad" enableRTL={true} />;
                }}
                onPressLeft={() => {
                    navigation.goBack();
                }}
            />
            <SafeAreaView style={BaseStyle.safeAreaView} edges={['right', 'left']}>
                <KeyboardAvoidingView
                    behavior={Platform.OS === 'android' ? 'height' : 'padding'}
                    keyboardVerticalOffset={offsetKeyboard}
                    style={{ flex: 1 }}
                >
                    <ScrollView>
                        <View style={{ padding: 20, paddingBottom: 80 }}>
                            <TextInput
                                onChangeText={(v) => setForm('title', v)}
                                onFocus={() => {
                                    setState({
                                        ...state,
                                        titleError: '',
                                    });
                                }}
                                placeholder="Title *"
                                success={!state.titleError}
                                value={state.title}
                                style={{ marginTop: 15, height: 45, borderRadius: 3 }}
                                onSubmitEditing={() => abbreviationInput.current.focus()}
                                textError={state.titleError}
                            />
                            <TextInput
                                inputRef={abbreviationInput}
                                onChangeText={(v) => setForm('abbreviation', v)}
                                onFocus={() => {
                                    setState({
                                        ...state,
                                        abbreviationError: '',
                                    });
                                }}
                                placeholder="Abkürzung *"
                                success={!state.abbreviationError}
                                value={state.abbreviation}
                                style={{ marginTop: 15, height: 45, borderRadius: 3 }}
                                onSubmitEditing={() => descriptionInput.current.focus()}
                                textError={state.abbreviationError}
                            />
                            <TextInput
                                inputRef={descriptionInput}
                                onChangeText={(v) => setForm('description', v)}
                                onFocus={() => {
                                    setState({
                                        ...state,
                                        descriptionError: '',
                                    });
                                }}
                                placeholder="Beschreibung"
                                success={!state.descriptionError}
                                value={state.description}
                                style={{ marginTop: 15, height: 45, borderRadius: 3 }}
                                onSubmitEditing={() => phonenumberInput.current.focus()}
                                textError={state.descriptionError}
                            />
                            <View style={{ marginTop: 15 }}>
                                                            <CostumModal
                                                                title="Zugriff auswählen"

                                                                activator={
                                                                    <View
                                                                        style={[
                                                                            BaseStyle.textInput,
                                                                            {
                                                                                backgroundColor: BaseColor.card,
                                                                                minHeight: 45,
                                                                                borderRadius: 3,
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <View>
                                                                            {state.access ? (
                                                                                <Text footnote>{`${authorisations.find(auth=>auth.type==state.access).description} (${state.access})`}</Text>
                                                                            ) : (
                                                                                <Text style={{ color: state.accessError ? 'red' : BaseColor.grayColor }}>Zugriff auswählen *</Text>
                                                                            )}
                                                                        </View>
                                                                        <Icon name="chevron-right" size={15} color={BaseColor.gray} style={{ marginRight: 5 }} enableRTL={true} />
                                                                    </View>
                                                                }
                                                                renderComponent={(onApply) => (
                                                                    <View>
{authorisations?.map((auth, key) => (
                <TouchableOpacity
                    key={"auth_"+key}
                    style={{
                        flexDirection: 'row',
                        paddingVertical: 15,
                        borderBottomStyle: 'solid',
                        borderBottomWidth: 1,
                        borderBottomColor: BaseColor.grayLight,
                        paddingHorizontal: 20,
                        paddingBottom: 20,
                    }}
                    onPress={() => {setState(s=>({...s, access: auth.type, accessError:""}));onApply()}}
                >
                    <View style={{ borderRadius: 30, padding: 0, marginRight: 10 }}>
                        <Icon
                            name={auth.type == state.access ? 'check-circle' : 'circle'}
                            solid={auth.type == state.access}
                            color={auth.type == state.access? BaseColor.primary:'#ccccdd'}
                            size={20}
                        />
                    </View>
                    <View><Text >{`${auth.description}`}</Text>
                    {/* <Text semibold grayColor>{auth.type}</Text> */}
                    </View>
                </TouchableOpacity>
            ))}


                                                                    </View>
                                                                )}
                                                            />
                                                            <View style={{paddingTop:7}}>{state.accessError && <Text footnote grayColor>{state.accessError}</Text>}</View>
                                                        </View>
                          
                        </View>
                    </ScrollView>
                    <View style={{ position: 'absolute', bottom: 0, left: 0, width: '100%' }}>
                        <View style={{ alignItems: 'center', paddingBottom: 20 }}>
                            <Button
                                full
                                loading={state.creating}
                                onPress={handleSubmit}
                                style={{ marginTop: 15, width: '50%', height: 40 }}
                            >
                                {' '}
                                Speichern
                            </Button>
                        </View>
                    </View>
                </KeyboardAvoidingView>
            </SafeAreaView>
        </View>
    );
}

function mapState(state) {
    const { user } = state.users;
    const { all } = state.clients;
    const { creating } = state.users.all;
    return { user, creating, allClient: all };
}

const actionCreators = {
    createUser: userActions.register,
    getAllClient: clientActions.getAll,
};

export default connect(mapState, actionCreators)(CreatePosition);
